import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { STORAGE_TYPES } from 'common/constants/constants';
import { useRef } from 'react';

const useTablePersistExpandedRows = ({
  storageKey,
  storageType = STORAGE_TYPES.SESSION,
  getRowId = row => row.id
} = {}) => {
  const sessionStorageAccessor = BrowserStorageAccessor()[storageType];

  const expandedRows = useRef(
    new Set(JSON.parse(sessionStorageAccessor.get(storageKey)) || [])
  );

  const onExpandRow = (isExpanded, row) => {
    if (!storageKey) return;

    const rowId = getRowId(row);
    if (isExpanded) expandedRows.current.add(rowId);
    else expandedRows.current.delete(rowId);

    const sessionKeyValue = JSON.stringify(
      // Otherwise it will be stringified as "{}"
      Array.from(expandedRows.current)
    );

    sessionStorageAccessor.set(storageKey, sessionKeyValue);
  };

  const isRowExpanded = row => expandedRows.current.has(getRowId(row));

  return {
    isRowExpanded,
    onExpandRow
  };
};

export default useTablePersistExpandedRows;
